export default "/images/23fd2655bee25c71f153289ba61825e8.avif";